import { cva } from "class-variance-authority"

export const textareaBaseVariants = cva(
  "flex w-full rounded-md placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        outline:
          "border border-input bg-transparent shadow-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        secondary:
          "border border-transparent bg-secondary text-secondary-foreground shadow-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        ghost:
          "border border-transparent bg-transparent focus-visible:border-input focus-visible:shadow-sm",
      },
      size: {
        tiny: "min-h-[60px] px-2 py-0.5 text-xs rounded-sm",
        xs: "min-h-[60px] px-2 py-1 text-sm rounded-sm",
        sm: "min-h-[60px] px-3 py-1.5 text-sm rounded-sm",
        md: "min-h-[60px] px-3 py-2 text-sm",
        lg: "min-h-[80px] px-4 py-2.5 text-base",
      },
    },
    defaultVariants: {
      variant: "outline",
      size: "md",
    },
  },
)
